import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, Observable } from 'rxjs';

// entorno y librerias
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

// Interfaces
import { IApiResp } from '../interfaces/api-resp';

// Servicios
import { NotificacionesService } from './notificaciones.service';

@Injectable({
  providedIn: 'root'
})
export class EanLabelsService {

  private apiURL: string = environment.apiURL;

  constructor(
    private http: HttpClient,
    private notificacionesSrv: NotificacionesService
  ) { }

  /**
   * Muestra SweetAlert con opciones de impresión y ejecuta la API
   * @param id_articulo ID del artículo a imprimir
   */
  async imprimirEanLabel(id_articulo: string | number): Promise<void> {

    const result = await Swal.fire({
      title: 'Generar Etiquetas EAN',
      text: `¿Cuántas etiquetas deseas imprimir para el artículo ${id_articulo}?`,
      icon: 'question',
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: 'Cancelar',
      html: `
      <div style="margin-top: 10px;">
        <p style="font-size: 1.1em; margin-bottom: 15px;">
          Carga el papel de etiquetas (3x8) y selecciona la cantidad de etiquetas a imprimir
        </p>
        <div>
          <button id="btn12" class="swal2-confirm swal2-styled" style="margin: 0 10px; background-color: #3085d6;">
            12 Etiquetas
          </button>
          <button id="btn24" class="swal2-confirm swal2-styled" style="margin: 0 10px; background-color: #28a745;">
            24 Etiquetas
          </button>
        </div>
      </div>
    `,
      didOpen: () => {
        // Evento para botón de 12 etiquetas
        const btn12 = Swal.getPopup()?.querySelector('#btn12');
        btn12?.addEventListener('click', () => {
          Swal.close();
          this.imprimirEtiquetas(id_articulo, 12);
        });

        // Evento para botón de 24 etiquetas
        const btn24 = Swal.getPopup()?.querySelector('#btn24');
        btn24?.addEventListener('click', () => {
          Swal.close();
          this.imprimirEtiquetas(id_articulo, 24);
        });
      }
    });
  }



  /**
   * Ejecuta la llamada a la API para imprimir etiquetas
   * @param id_art ID del artículo
   * @param cantidad Cantidad de etiquetas a imprimir
   */
  private async imprimirEtiquetas(id_art: string | number, cantidad: number): Promise<void> {

    // Mostrar loading
    Swal.fire({
      title: 'Generando etiquetas...',
      text: `Enviando ${cantidad} etiquetas para el artículo ${id_art}`,
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      // Llamada a la API
      this.callPrintAPI(id_art, cantidad).subscribe(resp => {
        console.log('Respuesta de la API:', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje || 'Error al imprimir etiquetas')

          // Cerrar loading
          Swal.close();
          return
        }

        // Todo ok, Abrir PDF en una nueva pestaña

        const urlPdf: string = environment.pdfDir + '/etiquetasEan/' + resp.data.id + '.pdf';
        window.open(urlPdf, '_blank');
        this.notificacionesSrv.aviso('success', resp.mensaje);

        // Cerrar loading
        Swal.close();
      });





    } catch (error: any) {
      // Mostrar error
      Swal.fire({
        title: 'Error de Impresión',
        text: error?.error?.message || 'Ha ocurrido un error al imprimir las etiquetas',
        icon: 'error',
        confirmButtonText: 'Entendido'
      });
    }
  }

  /**
   * Llamada HTTP a la API de impresión
   */
  private callPrintAPI(id_art: string | number, cantidad: number): Observable<any> {
    const payload = {
      id_art: id_art,
      cantidad: cantidad
    };

    const path = `${this.apiURL}/articulos/eanPrint`;
    return this.http.post<IApiResp>(path, payload)
  }


}